<template>
    <div class="refund">
        <h3>退款管理</h3>
        <el-form :inline="true" class="demo-form-inline" v-loading="loading" size="mini">

            <el-form-item label="订单编号">
                <el-input v-model="filter.orderId" placeholder="订单编号"></el-input>
            </el-form-item>

            <el-form-item label="用户昵称">
                <el-input v-model="filter.nickname" placeholder="用户昵称"></el-input>
            </el-form-item>

            <el-form-item label="审核状态">
                <el-select v-model="filter.status">
                    <el-option v-for="val,key in status" :key="key" :value="key" :label="val"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="退款单号">
                <el-input v-model="filter.id" placeholder="退款单号"></el-input>
            </el-form-item>

            <el-form-item label="付款账号">
                <el-input v-model="filter.cardNo" placeholder="付款账号"></el-input>
            </el-form-item>

            <el-form-item label="户名">
                <el-input v-model="filter.accountName" placeholder="户名"></el-input>
            </el-form-item>

            <el-form-item>
                <el-button-group>
                    <el-button type="primary" @click="search" size="mini">查询</el-button>
                </el-button-group>
            </el-form-item>

        </el-form>
        <el-table :data="list" size="mini">
            <el-table-column prop="id" label="退款单号"></el-table-column>
            <el-table-column prop="orderId" label="订单编号"></el-table-column>
            <el-table-column prop="nickName" label="用户昵称"></el-table-column>
            <el-table-column prop="accountName" label="户名"></el-table-column>
            <el-table-column prop="refund" label="退款金额"></el-table-column>
            <el-table-column prop="createTime" label="申请时间"></el-table-column>
            <el-table-column prop="updateTime" label="退款时间"></el-table-column>
            <el-table-column prop="cardNo" label="账号"></el-table-column>
            <el-table-column prop="bank" label="开户行"></el-table-column>
            <el-table-column label="退款状态">
                <template slot-scope="scope">{{status[scope.row.status]}}</template>
            </el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button size="mini" :disabled="scope.row.status !== 0" @click="update(scope.row)">退款</el-button>
                </template>
            </el-table-column>
        </el-table>
        <br/>
        <div style="float: right">
            <el-pagination background layout="prev, pager, next" :page-size="20" @current-change="i=>pageNum=i" :page-count="pageNum" :total="total" ref="pagination">
            </el-pagination>
        </div>
    </div>
</template>
<script>
import api from '../api'
const {
    refund
} = api

import moment from 'moment'

export default {
    name: "refund",
    data() {
        return {
            loading: true,

            list: [],
            total: 0,
            pageNum: 1,
            limit: 20,
            filter: {
                id: '',
                orderId: '',
                status: '0',
                nickname: '',
            },
            status: {
                '0': '未审核',
                '1': '已确认',
                '2': '全部',
            }
        };
    },
    watch: {
        pageNum() {
            this.fetch()
        }
    },
    methods: {
        async fetch() {
            this.loading = true;
            let {
                id,
                orderId,
                status,
                nickname,
            } = this.filter
            let obj = {
                id,
                orderId,
                status,
                nickname,
                pageNum: this.pageNum,
                limit: this.limit,
            }

            let res = await refund.list(obj);
            this.list = res.data.data;
            this.loading = false;
            this.total = res.data.pageinfo.totalCount
        },
        async update(item) {
            let res = await refund.update({
                id: item.id
            })

            let {
                code
            } = res.data
            if (code === 200) {
                this.$message.success('更新数据成功 ')
            }
            this.fetch()
        },
        async search() {
            this.$refs.pagination.internalCurrentPage = 1
            this.pageNum = 1
            this.fetch()
        }

    },
    mounted() {
        this.fetch();
    }
};
</script>
<style>
.user-list {}
</style>


// WEBPACK FOOTER //
// src/views/finance/refund.vue